export default "__VITE_ASSET__BFRp4uVb__"